// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColStyle {
  display: flex;
  align-items: center;
}

.CollNameStyle {
  font-family: "Roboto-Slab Bold";
  font-style: normal;
  font-size: 20px;
  color: #12394d;
  align-items: center;
}

.DataStyle {
  font-family: "Roboto";
  font-style: normal;
  font-size: 16px;
}

.IconStyle {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  stroke: none;
  fill: #cc0000;
}

.ButtonStyle {
  background-color: #cc0000;
  border: none;
}

.CopyButtonStyle {
  background-color: #97c294;
  border: none;
}

.CloseBtnStyle {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.PageNumberInput {
  width: 4rem;
  height: 2rem;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.PageNumberInput:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.my-modal .modal-dialog {
  max-width: 90%;
  max-height: 90vh;
  margin: auto;
}

.my-modal .modal-content {
  border-radius: 10px;
  overflow: hidden;
}

.my-modal .modal-body {
  background: #f7f7f7;
}

.FooterStyle {
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  padding: 16px;
}

.FeedbackButton,
.CloseButton {
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  min-width: 132px;
  min-height: 44px;
  padding: 10px 18px;
}

.FeedbackButton {
  background-color: #0d6efd;
}

.FeedbackButton:hover,
.FeedbackButton:focus {
  background-color: #0b5ed7;
}

.CloseButton {
  background-color: #cc0000;
}

.CloseButton:hover,
.CloseButton:focus {
  background-color: #a30000;
}

.PdfContentRow {
  align-items: stretch;
  display: flex;
  gap: 16px;
  width: 100%;
}

.TranslationPaneInline {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  flex: 0 0 34%;
  flex-direction: column;
  min-width: 280px;
  overflow: hidden;
}

.FeedbackPaneInline {
  background: #ffffff;
  border-left: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex: 0 0 320px;
  flex-direction: column;
  gap: 10px;
  max-width: 360px;
  min-width: 280px;
  padding: 16px;
}

.FeedbackPaneHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.FeedbackPaneHeader h5 {
  color: #212529;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.FeedbackPaneHeader .btn-link {
  color: #0d6efd;
  font-size: 20px;
  line-height: 1;
  padding: 0 2px;
  text-decoration: none;
}

.FeedbackSummary {
  color: #333;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 6px;
  margin-bottom: 12px;
}

.FeedbackPaneInline .form-label {
  color: #212529;
  font-size: 15px;
  margin-bottom: 8px;
}

.FeedbackPaneInline .form-select,
.FeedbackPaneInline .form-control {
  border-color: #d7dde3;
  border-radius: 6px;
  color: #212529;
  font-size: 15px;
}

.FeedbackPaneInline textarea.form-control {
  min-height: 150px;
  resize: vertical;
}

.FeedbackPaneActions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: auto;
}

@media (max-width: 1200px) {
  .PdfContentRow {
    flex-wrap: wrap;
  }

  .TranslationPaneInline,
  .FeedbackPaneInline {
    flex: 1 1 100%;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pdf-modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".ColStyle {\n  display: flex;\n  align-items: center;\n}\n\n.CollNameStyle {\n  font-family: \"Roboto-Slab Bold\";\n  font-style: normal;\n  font-size: 20px;\n  color: #12394d;\n  align-items: center;\n}\n\n.DataStyle {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-size: 16px;\n}\n\n.IconStyle {\n  width: 16px;\n  height: 16px;\n  margin-right: 5px;\n  stroke: none;\n  fill: #cc0000;\n}\n\n.ButtonStyle {\n  background-color: #cc0000;\n  border: none;\n}\n\n.CopyButtonStyle {\n  background-color: #97c294;\n  border: none;\n}\n\n.CloseBtnStyle {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.PageNumberInput {\n  width: 4rem;\n  height: 2rem;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.PageNumberInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.my-modal .modal-dialog {\n  max-width: 90%;\n  max-height: 90vh;\n  margin: auto;\n}\n\n.my-modal .modal-content {\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.my-modal .modal-body {\n  background: #f7f7f7;\n}\n\n.FooterStyle {\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  justify-content: flex-end;\n  gap: 14px;\n  padding: 16px;\n}\n\n.FeedbackButton,\n.CloseButton {\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 16px;\n  min-width: 132px;\n  min-height: 44px;\n  padding: 10px 18px;\n}\n\n.FeedbackButton {\n  background-color: #0d6efd;\n}\n\n.FeedbackButton:hover,\n.FeedbackButton:focus {\n  background-color: #0b5ed7;\n}\n\n.CloseButton {\n  background-color: #cc0000;\n}\n\n.CloseButton:hover,\n.CloseButton:focus {\n  background-color: #a30000;\n}\n\n.PdfContentRow {\n  align-items: stretch;\n  display: flex;\n  gap: 16px;\n  width: 100%;\n}\n\n.TranslationPaneInline {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  display: flex;\n  flex: 0 0 34%;\n  flex-direction: column;\n  min-width: 280px;\n  overflow: hidden;\n}\n\n.FeedbackPaneInline {\n  background: #ffffff;\n  border-left: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex: 0 0 320px;\n  flex-direction: column;\n  gap: 10px;\n  max-width: 360px;\n  min-width: 280px;\n  padding: 16px;\n}\n\n.FeedbackPaneHeader {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.FeedbackPaneHeader h5 {\n  color: #212529;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.FeedbackPaneHeader .btn-link {\n  color: #0d6efd;\n  font-size: 20px;\n  line-height: 1;\n  padding: 0 2px;\n  text-decoration: none;\n}\n\n.FeedbackSummary {\n  color: #333;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.FeedbackPaneInline .form-label {\n  color: #212529;\n  font-size: 15px;\n  margin-bottom: 8px;\n}\n\n.FeedbackPaneInline .form-select,\n.FeedbackPaneInline .form-control {\n  border-color: #d7dde3;\n  border-radius: 6px;\n  color: #212529;\n  font-size: 15px;\n}\n\n.FeedbackPaneInline textarea.form-control {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.FeedbackPaneActions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n@media (max-width: 1200px) {\n  .PdfContentRow {\n    flex-wrap: wrap;\n  }\n\n  .TranslationPaneInline,\n  .FeedbackPaneInline {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
